// @flow
export const DOMAIN_NAME: string = 'session-service'

export const CSRF_COOKIE_NAME: string = '_csrf_token'

export const SESSION_ID_STORAGE_KEY: string = 'foxfordSessionId'
